
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collegeList",
      function () {
        return require("private-next-pages/collegeList.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collegeList"])
      });
    }
  